import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculateDiscountPrice',
  standalone: false,
})
export class CalculateDiscountPipe implements PipeTransform {
  transform(price: number | undefined, discountAmount: number | undefined, discountUnit: string | undefined): string {
    if (price === undefined || discountAmount === undefined) {
      return '';
    }

    if (discountUnit === 'percent') {
      const percentageCalc = (price * discountAmount) / 100;
      return `${(price - percentageCalc).toFixed(2)} €`;
    } else if (discountUnit === 'absolute') {
      return `${(price - discountAmount).toFixed(2)} €`;
    } else {
      return '';
    }
  }
}
